module.exports = [
'Nyeusi',
'Fedha',
'Kijivu',
'Udongo',
'Kahawia',
'Chokoleti',
'Kutu',
'Shaba',
'Hudhurungi',
'Ukaria',
'Marungi',
'Zambarau',
'Urujuani',
'Nili',
'Buluu',
'Samawati',
'Feruzi',
'Kijani',
'Zaituni',
'Zumaridi',
'Chanikiwiti',
'Ndimu',
'Manjano',
'Mahindi',
'Dhahabu',
'Kaharabu',
'Machungwa',
'Nyekundu',
'Waridi',
'Pinki',
'Nyeupe',
'Lulu',
'Mtindi',

];